import { Select as AntdSelect, SelectProps } from "antd";
import styled from "styled-components";

const StyledSelect = styled(AntdSelect)`
  width: 100% !important;
`;

const SelectOption = StyledSelect.Option;

const Select = ({ ...props }: SelectProps) => {
  // @ts-ignore
  return <StyledSelect {...props} />;
};

export default Select;
export { SelectOption };
